import { AuroraBackgroundDemo } from "@/components/ui/aurora-background-demo";
import { ServicesSection, StatsSection, ContactSection } from "@/components/sections";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/ui/whatsapp-float";
import SEO from "@/components/SEO";
import BackToTop from "@/components/ui/back-to-top";

const Index = () => {
  console.log('🎯 Index.tsx: Loading complete Future Station site...');
  
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Future Station - Transforme seu Fluig em uma máquina de produtividade"
        description="Future Station - Líder em consultoria Fluig e TOTVS no Brasil. Mais de 10 anos automatizando processos corporativos com ROI comprovado. Diagnóstico gratuito disponível."
        keywords={['fluig consultor', 'totvs fluig', 'consultoria fluig', 'automação processos', 'bpm fluig', 'ecm totvs', 'workflow corporativo']}
        type="website"
      />
      {/* Header */}
      <Header />
      
      {/* Main Content */}
      <main>
        {/* Hero Section with Aurora Background */}
        <section id="hero">
          <AuroraBackgroundDemo />
        </section>

        {/* Services Section */}
        <section id="services">
          <ServicesSection />
        </section>
        
        {/* Stats Section */}
        <StatsSection />

        {/* Contact Section */}
        <section id="contact">
          <ContactSection />
        </section>
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* WhatsApp Float Button */}
      <WhatsAppFloat />
      
      {/* Back to Top Button */}
      <BackToTop />
    </div>
  );
};

export default Index;